function initSingleHigherStandard() {
  if ($('.single-higher-standard').length == 0) {
    return false;
  }

  const backButton = $('#higher-standard-back');
  const prevUrl = document.referrer;

  if (prevUrl.indexOf('?') > -1) {
    backButton.on('click', function () {
      history.go(-1);
    });
  } else {
    backButton.on('click', function () {
      location.href = backButton.data('url');
    });
  }
}

export { initSingleHigherStandard };



// WEBPACK FOOTER //
// ./scripts/pages/single-higher-standard.js